import Flickity from 'flickity';
import 'flickity-imagesloaded';
import 'flickity/dist/flickity.css';

const cardCarousels = document.querySelectorAll('[data-card-carousel]');

[...cardCarousels].forEach((cardCarousel) => {
    const flckty = new Flickity(cardCarousel, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        imagesLoaded: true,
    });

    flckty.reloadCells();

    setTimeout(() => {
        flckty.reloadCells();
    }, 1000);
});



// WEBPACK FOOTER //
// ./resources/components/card-carousel/card-carousel.js